import type { DriveStep } from "driver.js";

export const POS_TOUR_STEPS: DriveStep[] = [
  {
    element: '[data-tour="pos-guest-scan"]',
    popover: {
      title: "Gast wählen",
      description:
        "Scannen Sie Platznummer, Schlüssel, Transponder oder geben Sie den Gastnamen ein. Alternativ verkaufen Sie ohne Gast an Laufkundschaft.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="pos-tiles"]',
    popover: {
      title: "Artikelkacheln",
      description:
        "Tippen Sie auf eine Kachel, um Artikel in den Warenkorb zu legen. Die Kacheln sind unter Stammdaten konfigurierbar.",
      side: "top",
      align: "start",
    },
  },
  {
    element: '[data-tour="pos-payment"]',
    popover: {
      title: "Zahlung abschließen",
      description:
        "Wählen Sie die Zahlungsart und schließen Sie den Verkauf mit F2 oder dem Bezahlen-Button ab. Bei Kartenzahlung kann das EC-Terminal direkt angesprochen werden.",
      side: "top",
      align: "start",
    },
  },
];
